// extracted by mini-css-extract-plugin
export default {"qrscannerdiv":"qrscanner_qrscannerdiv__HAecX"};